import React from 'react'
// import { FiBook, FiCalendar, FiMapPin } from 'react-icons/fi'
import { Stethoscope, CalendarCheck, MapPin } from 'lucide-react'; // أيقونات احترافية من Lucide React


const WhyUseTele = () => {


     return (
        <section className="py-20 bg-gray-50"> {/* خلفية خفيفة لتمييز القسم */}
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <h2 className="text-4xl font-extrabold text-center mb-16 text-teal-800">
                    لماذا تختار <span className="text-blue-600">حَكّمني</span>؟
                </h2>
                <div className="grid md:grid-cols-3 gap-8 lg:gap-12">
                    {/* الميزة الأولى: أطباء معتمدون */}
                    <div className="text-center p-8 bg-white rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300 ease-in-out border border-teal-100 transform hover:-translate-y-2">
                        <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
                            <Stethoscope className="w-10 h-10 text-teal-600" /> {/* أيقونة السماعة الطبية */}
                        </div>
                        <h3 className="text-2xl font-bold mb-3 text-gray-800">أطباء موثوقون</h3>
                        <p className="text-gray-600 leading-relaxed text-lg">
                            نخبة من الأطباء المعتمدين وذوي الخبرة في كافة التخصصات الطبية، لضمان أعلى جودة رعاية.
                        </p>
                    </div>

                    {/* الميزة الثانية: سهولة ومرونة الحجز */}
                    <div className="text-center p-8 bg-white rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300 ease-in-out border border-teal-100 transform hover:-translate-y-2">
                        <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                            <CalendarCheck className="w-10 h-10 text-blue-600" /> {/* أيقونة التقويم والعلامة */}
                        </div>
                        <h3 className="text-2xl font-bold mb-3 text-gray-800">مواعيد مرنة</h3>
                        <p className="text-gray-600 leading-relaxed text-lg">
                            احجز موعدك بسهولة وفي الوقت الذي يناسبك، مع إمكانية التعديل والإلغاء بمرونة.
                        </p>
                    </div>

                    {/* الميزة الثالثة: البحث عن الأقرب إليك */}
                    <div className="text-center p-8 bg-white rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300 ease-in-out border border-teal-100 transform hover:-translate-y-2">
                        <div className="w-20 h-20 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-6">
                            <MapPin className="w-10 h-10 text-purple-600" /> {/* أيقونة تحديد الموقع */}
                        </div>
                        <h3 className="text-2xl font-bold mb-3 text-gray-800">الأقرب إليك</h3>
                        <p className="text-gray-600 leading-relaxed text-lg">
                            ابحث عن الأطباء والعيادات القريبة من موقعك، ووفر الوقت والجهد.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};
    // return (
    //     <section className="py-20">
    //         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    //             <h2 className="text-3xl font-bold text-center mb-12 text-gray-800">
    //                 لماذا تختار تلسكوب؟
    //             </h2>
    //             <div className="grid md:grid-cols-3 gap-8">
    //                 <div className="d text-center p-6 bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow">
    //                     <div className="w-16 h-16 bg-primary bg-opacity-10 rounded-full flex items-center justify-center mx-auto mb-4">
    //                         <FiBook className="icon w-8 h-8 text-white" />
    //                     </div>
    //                     <h3 className="text-xl font-semibold mb-3">معلمون مؤهلون</h3>
    //                     <p className="text-gray-600">
    //                         معلمون معتمدون وذوو خبرة في جميع المواد الدراسية
    //                     </p>
    //                 </div>

    //                 <div className="d text-center p-6 bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow">
    //                     <div className="w-16 h-16 bg-secondary bg-opacity-10 rounded-full flex items-center justify-center mx-auto mb-4">
    //                         <FiCalendar className="icon w-8 h-8 text-white" />
    //                     </div>
    //                     <h3 className="text-xl font-semibold mb-3">جدولة مرنة</h3>
    //                     <p className="text-gray-600">
    //                         احجز الدروس في الأوقات التي تناسبك
    //                     </p>
    //                 </div>

    //                 <div className="d text-center p-6 bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow">
    //                     <div className="icon w-16 h-16 bg-accent bg-opacity-10 rounded-full flex items-center justify-center mx-auto mb-4">
    //                         <FiMapPin className="w-8 h-8 text-accent text-white" />
    //                     </div>
    //                     <h3 className="text-xl font-semibold mb-3">قريب منك</h3>
    //                     <p className="text-gray-600">
    //                         ابحث عن المعلمين القريبين من موقعك
    //                     </p>
    //                 </div>
    //             </div>
    //         </div>
    //     </section>
    // )
// }

export default WhyUseTele